import {
  Check,
  CircleAlert,
  GitBranch,
  History,
  Image as ImageIcon,
} from "lucide-react";
import { useState } from "react";

import CatalogRecordPreview from "./CatalogRecordPreview";

const parentLabels = [
  "Catalog category",
  "Game",
  "Game variant",
  "Era / series",
  "Parent set",
];

export default function CatalogInspector({
  form,
  parentOptions,
  record,
  status,
}) {
  const [tab, setTab] = useState("preview");
  const required = [
    ["Official name", Boolean(form.name?.trim())],
    ["Display name", Boolean(form.display_name?.trim())],
    ["Release date", Boolean(form.release_date)],
    ["Primary image", Boolean(form.images?.primary_image_id)],
  ];
  const parents = Object.values(form.parents || {}).filter(Boolean);

  return (
    <aside className="catalog-inspector" data-testid="catalog-inspector">
      <div className="catalog-inspector-tabs" role="tablist">
        {["preview", "hierarchy", "validation", "history"].map((name) => (
          <button
            aria-selected={tab === name}
            className={tab === name ? "is-active" : ""}
            key={name}
            onClick={() => setTab(name)}
            role="tab"
            type="button"
            data-testid={`catalog-inspector-tab-${name}`}
          >
            {name}
          </button>
        ))}
      </div>
      <div
        className="catalog-inspector-content"
        role="tabpanel"
        data-testid={`catalog-inspector-${tab}`}
      >
        {tab === "preview" && (
          <CatalogRecordPreview
            form={form}
            parentOptions={parentOptions}
            status={status}
          />
        )}
        {tab === "hierarchy" && (
          <div className="catalog-inspector-stack">
            <GitBranch size={19} />
            <h3>Catalog hierarchy</h3>
            {parents.length ? (
              parentLabels.map((label, index) => (
                <div className="catalog-inspector-node" key={label}>
                  <span>{label}</span>
                  <strong>
                    {parents[index] ? "Linked record" : "Not linked"}
                  </strong>
                </div>
              ))
            ) : (
              <p>Add relationships to see this record’s path.</p>
            )}
          </div>
        )}
        {tab === "validation" && (
          <div className="catalog-inspector-stack">
            <CircleAlert size={19} />
            <h3>Ready-to-publish check</h3>
            {required.map(([label, complete]) => (
              <div
                className={
                  complete
                    ? "catalog-validation-row is-complete"
                    : "catalog-validation-row"
                }
                key={label}
              >
                {complete ? <Check size={15} /> : <ImageIcon size={15} />}
                <span>
                  {complete
                    ? `${label} complete`
                    : `Missing ${label.toLowerCase()}`}
                </span>
              </div>
            ))}
          </div>
        )}
        {tab === "history" && (
          <div className="catalog-inspector-stack">
            <History size={19} />
            <h3>Record history</h3>
            {record ? (
              <>
                <p>Created by {record.created_by_name || "Cardfolio"}</p>
                <p>
                  Last updated {new Date(record.updated_at).toLocaleString()}
                </p>
              </>
            ) : (
              <p>Save this draft to begin its audit history.</p>
            )}
          </div>
        )}
      </div>
    </aside>
  );
}
